/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import "../assets/stylesheets/app.scss";
import { renderApplication, preRenderApplication } from "./render";
import { fetchLoggedInEvolokUser, fetchEvAuthorize, fetchLocation } from "../isomorphic/api";
import wretch from "wretch";
import { get } from "lodash";

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

const CUSTOM_REDUCERS = {
  user(state = null, action) {
    switch (action.type) {
      case "ADD_USER":
        return { ...action.user };
      default:
        return state;
    }
  },
  storiesCounter(state = { remainingStoriesCount: null }, action) {
    switch (action.type) {
      case "UPDATE_STORIES_READ_STATS":
        return { remainingStoriesCount: action.remainingStoriesCount };
      default:
        return state;
    }
  }
};

global.wretch = wretch;

global.qtNoAutomaticGATracking = true;

const evolokWithLogin = Promise.all([fetchLoggedInEvolokUser(), fetchEvAuthorize(), fetchLocation()]).then(res => {
  return res;
});

global.userPromise = new Promise((resolve, reject) => {
  evolokWithLogin.then(([userData, segmentData, locationData]) => {
    const segments = segmentData.segments || [];
    const loggedOutStat = get(segmentData, ["loggedOut"], true);
    let user = userData.user || {};
    user.location = locationData;

    if (user && user.userId && global.navigator && global.navigator.sendBeacon) {
      global.navigator.sendBeacon(`/api/vikatan/v1/ping-user/${user.userId}`);
    }

    if (user) {
      user.userType = segmentUserType(segments);
      user.loggedOut = loggedOutStat;

      resolve(user);
    } else {
      resolve(user);
    }
  });
});

const segmentUserType = segments => {
  let evUserType = [];
  if (segments.includes("P") || segments.includes("T") || segments.includes("R")) {
    evUserType = segments.filter(x => x === "P" || x === "T" || x === "R");
  } else if (segments.includes("F") || segments.includes("E")) {
    evUserType = segments.filter(x => x === "F" || x === "E");
  } else {
    evUserType = [];
  }
  return evUserType.length > 0 ? evUserType[0] : "";
};

global.paywallPromise = { type: "B", "std-link": "https://store.vikatan.com/?utm_source=standard_pw" };

startApp(renderApplication, CUSTOM_REDUCERS, {
  enableServiceWorker: process.env.NODE_ENV === "production",
  enableFCM: true,
  appVersion: require("../isomorphic/app-version"),
  preRenderApplication
}).then(enableHotReload);
